export default "__VITE_ASSET__67c257c7__"